import './Logo.css';

interface LogoProps {
  size?: 'small' | 'medium' | 'large';
}

export function Logo({ size = 'medium' }: LogoProps) {
  const sizeClasses = {
    small: 'logo-small',
    medium: 'logo-medium',
    large: 'logo-large'
  };

  return (
    <div className={`logo ${sizeClasses[size]}`}>
      <img src="/nostavia-logo.png" alt="Nostavia" className="logo-image" />
    </div>
  );
}
